<template>
  <div class="currency-record">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="支付类型">
        <Select v-model="searchCondition.pay_type" class="com-width" clearable>
          <Option v-for="item in payType" :value="item.key" :key="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="充值时间">
        <DatePicker
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          style="width:280px"
          @on-change="onDateRange"
          :editable="false"
          clearable
        ></DatePicker>
      </FormItem>
      <FormItem label="手机号">
        <Input
          v-model="searchCondition.mobile"
          placeholder="请输入买家手机号"
          style="width:200px"
          clearable
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/balance/order"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="order_number"
        method="get"
      ></Grid>
    </div>
  </div>
</template>

<script>
import { PayType } from "@/utils/enums";

export default {
  name: "currency-record",
  data() {
    return {
      payType: PayType.getOptions(),
      searchCondition: {
        pay_type: "",
        created_start: "",
        created_end: "",
        mobile: "",
        init() {
          this.pay_type = "";
          this.created_start = "";
          this.created_end = "";
          this.mobile = "";
        }
      },
      tableColumns: [
        { title: "订单编号", key: "order_number", minWidth: 200 },
        {
          title: "充值金额",
          key: "change_price",
          align: "center",
          minWidth: 170
        },
        {
          title: "支付类型",
          key: "pay_type_name",
          align: "center",
          minWidth: 100
        },
        { title: "充值用户", key: "nickname", align: "center", minWidth: 170 },
        { title: "用户手机号", key: "mobile", align: "center", minWidth: 120 },
        { title: "充值时间", key: "created_at", align: "center", minWidth: 170 }
      ]
    };
  },
  methods: {
    // on event
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.formDate.handleClear();
      this.$refs.grid.searchRefresh();
    },
    onDateRange(range) {
      this.searchCondition.created_start = range[0];
      this.searchCondition.created_end = range[1];
    },
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.change_price = this.$pub.calcPrice(i.change_price);
        i.pay_type_name = PayType.getValue(i.pay_type);
        i.created_at = this.$pub.timestampToTime(i.created_at);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>